import { type FC } from 'react';

import { BackgroundWrapper } from '@/components/ui/BackgroundWrapper/BackgroundWrapper';

import css from './styles.module.scss';

const Background: FC = () => {
  return (
    <BackgroundWrapper className="w-full h-full absolute top-0 left-0 overflow-hidden rounded-t-2xl">
      <span className={css.ellipse}></span>
      <div className={css.gradient}></div>
    </BackgroundWrapper>
  );
};

export { Background };
